import React, { useState} from 'react'
import LoadingButton from '@mui/lab/LoadingButton'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { TextInput, useTranslate, useNotify, required, Form, Create, useRedirect } from 'react-admin'
import { Grid, Box, Typography, Container, Button, TextField } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { paymentServices } from 'src/services/payment/Payment.service'
import { getTotal } from 'src/components/pages/payment/payment/logic/common/getTotal'
import { extractDetails } from 'src/components/pages/payment/payment/logic/common/extracDetails'
import { reverseExchangeRate } from 'src/components/pages/payment/payment/logic/common/calculateReverseExchangeRate'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_RECEIPT } from 'src/helper/Permission'
import { useErrorHandler } from 'src/hooks/useErrorHandler'
import CancelIcon from '@mui/icons-material/Cancel';

const SearchComponent = ({reservation, index, reservations, setReservations, paymentData, setPaymentData, setWasFound}) =>{
  const translate = useTranslate()
  const [loading, setLoading] = useState(false)
  const notify = useNotify()
  const onSubmit = async (data, index, reserve) => {
    const reservationResponse = await searchReservationByNumber(data, index, reserve)
    setDataInPaymentData(reservationResponse,index)
  }

  const onChangeAmount = (index, value) =>{
    let payment = { ...paymentData }
    let reservationsAux = payment.form_data.reservation
    if(reservationsAux){
      let particularReserve = reservationsAux[index];
      particularReserve['amount_to_pay'] = Number(value)
      let auxReserves = [...reservations]
      auxReserves[index]['amount_to_pay'] = Number(value)
      setReservations(auxReserves)
      payment['form_data'] = { ...payment.form_data, reservation: reservationsAux }
      setPaymentData(payment)
    }
    
  }

  const setDataInPaymentData = (reservation,index) => {
    let payment = { ...paymentData }
    const reservationData = {
      number: reservation.number,
      passenger: reservation?.passenger,
      user: reservation?.user,
      /* amount_to_pay: data['amount_to_pay-'+reservation.id], */
      hash_reservation:reservation?.hash_reservation
    }
    let reservationsAux = payment.form_data.reservation
    if(reservationsAux){
      reservationsAux[index] = reservation ? reservationData : null
    } else {
      reservationsAux = []
      for(let _ of Array.from({length:index - 1})){
        reservationsAux.push({})
      }
      reservationsAux[index] = reservation ? reservationData : null
    }
    payment['form_data'] = { ...payment.form_data, reservation: reservationsAux }
    setPaymentData(payment)
  }

  const searchReservationByNumber = async (data, index, reserve) => {
    const  number  = data[`number${reserve?.id ?? ''}`]
    try {
      setLoading(true)
      const reservation = await reservationServices.getOneByParams({
        number__ilike_in: number,
        status__in: 'OPEN',
        min_columns: true,
      })
      if (reservation && Array.isArray(reservation) && reservation.length === 1) {
        let reservationsAux = reservations;
        reservationsAux[index] = reservation[0]
        setReservations(reservationsAux)
        setWasFound(true)
        onSuccess(number)
        return reservation[0]
      }
      setWasFound(false)
      onError(number)
      return null
    } catch (error) {
      setWasFound(false)
      onError(number)
    } finally {
      setLoading(false)
    }
  }
  const onSuccess = (reservation_number) => {
    notify('ra.message.reservation_found', {
      type: 'success',
      messageArgs: { reservation_number: reservation_number },
    })
  }

  const onError = (reservation_number) => {
    notify('ra.message.reservation_not_found', {
      type: 'error',
      messageArgs: { reservation_number: reservation_number },
    })
  }

  const onCancelReservation = (index) =>{
    const previousReserves = paymentData.form_data?.reservation
    const auxReservations = [...reservations]
    auxReservations.splice(index, 1)
    setReservations(auxReservations)
    if(previousReserves){
      previousReserves.splice(index, 1)
      paymentData['form_data'] = { ...paymentData.form_data, reservation: previousReserves }
      setPaymentData(paymentData)
    }
  }
  return(
    <>
    {<Create key={index}>
      <Form id={'search_reservation' + index} onSubmit={(data)=>onSubmit(data, index, reservation)} record={paymentData?.form_data?.reservation?.length > 0 ?? paymentData?.form_data?.reservation[index]}>
        <Grid container item>
        <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-evenly'}}>
          {!(reservations[index] && Object.keys(reservations[index] ?? []).length > 0) &&
          <EditInputsWrap label={translate('ra.field.reservation_number')} md={6} lg={6} required>
            <TextInput key={'number' + reservation.id} source={`number${reservation.id ?? ''}`} label='' validate={[required()]} fullWidth />
          </EditInputsWrap>
          }
          
          <EditInputsWrap label={null} md={12} lg={12}>
            <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>
               {!(reservations[index] && Object.keys(reservations[index] ?? []).length > 0) ?
                <LoadingButton
                  variant='contained'
                  form={'search_reservation' + index}
                  type='submit'
                  loading={loading}
                  disabled={(reservations[index] && Object.keys(reservations[index] ?? []).length > 0) }
                >
                  {translate('ra.action.search')}
                </LoadingButton>
                :<div></div>
                }
                <CancelIcon onClick={()=>onCancelReservation(index)} style={{cursor:'pointer', display:'flex'}}/>
            </div>
          </EditInputsWrap>
          </div>
          {reservations?.length > 0 && (
            <Grid container item>
              <EditInputsWrap label={translate('ra.field.reservation_number')} md={4} lg={4}>
                <Typography variant='h6' component='h6'>
                  {reservations[index]?.number}
                </Typography>
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.passenger')} md={4} lg={4}>
                <Typography variant='h6' component='h5'>
                  {reservations[index]?.passenger}
                </Typography>
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.seller')} md={4} lg={4}>
                <Typography variant='h6' component='h5'>
                  {reservations[index]?.user}
                </Typography>
              </EditInputsWrap>
            </Grid>
          )}
          {(reservations[index] && Object.keys(reservations[index] ?? []).length > 0) &&
          <EditInputsWrap  label={translate('ra.field.amount_to_pay')} md={6} lg={6}>
            <TextInput key={'amount' + reservation.id}  /* value={reserve.amount_to_pay || ''}  */ type='number' onChange={(value)=>onChangeAmount(index, value.target.value)} source={`amount_to_pay${reservations[index].id}`} label='' fullWidth />
          </EditInputsWrap>
          }
        </Grid>
      </Form>
      
    </Create>}
    </>
  )
}

export const ReservationPayment = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const {
    paymentData,
    currency,
    paymentExchanges,
    setPaymentData,
    setPaymentCurrecies,
    setPaymentExchanges,
  } = usePaymentContext()
  const showError = useErrorHandler()
  const [wasFound, setWasFound] = useState(false)
  const [reservations, setReservations] = useState([{}])
  const [loadingGeneratePayment, setLoadingGeneratePayment] = useState(false)
  const [loadingGeneratePaymentWithReceipt, setLoadingGeneratePaymentWithReceipt] = useState(false)


  const onSuccessGeneratePayment = (data, reservation_number) => {
    /* showError(data, () => */
      notify('ra.message.reservation_payment_generate_success', {
        type: 'success',
        messageArgs: { reservation_number: reservation_number.join(',') },
      })
    /* ) */
  }

  const onErrorGeneratePayment = (error, reservation_number) => {
    showError(error, () =>
       notify('ra.message.reservation_payment_generate_error', {
        type: 'error',
        messageArgs: { reservation_number: reservation_number },
      })
    )
    redirect('/payment-entity')
    setPaymentData(null)
  }

  const generatePayment = async () => {
    try {
      
      const reservationsObj = []
      let to_pay_count = 0
      for(const reserv of paymentData.form_data.reservation){
        if(reserv && Object.keys(reserv).length > 0){
          if(!reserv.amount_to_pay){
            notify('ra.message.amount_to_pay_requiered', {type:'error'})
            return
          }
          to_pay_count = to_pay_count + (Number(reserv.amount_to_pay) ?? 0)
          reservationsObj.push({
            ...reserv,
            currency: currency?.hash_currency,
          })
        }
      }
      if(to_pay_count > getTotal(paymentData)){
        notify('ra.message.amount_to_pay_error', {type:'error'})
        return
      }
      if(!reservationsObj || reservationsObj.length === 0){
        notify('ra.message.noReservationsSelected', {type:'error'})
        return
      }
      const body = {
        paymentType: extractDetails(paymentData?.form_data?.paymentType),
        credit: paymentData?.form_data?.credit ?? [],
        date:paymentData?.form_data.date ?? '',
        currencies_exchange: reverseExchangeRate(paymentExchanges),
        hash_business_unit: paymentData?.hash_business_unit,
        amount: getTotal(paymentData),
        reservations: reservationsObj,
        generate_receipt: false,
      }
      setLoadingGeneratePayment(true)
      const generatePayment = await paymentServices.liquidateExpensesReservations(body)
      if (generatePayment) {
        let numberReservations = []
        for(const reserv in paymentData?.form_data?.reservation){
          numberReservations.push(reserv.number)
        }
        onSuccessGeneratePayment(generatePayment, numberReservations)
        redirect('/payment-entity')
        setPaymentData(null)
      }
    } catch (error) {
      onErrorGeneratePayment(error, paymentData?.form_data?.reservation?.number)
    } finally {
      setLoadingGeneratePayment(false)
      setPaymentCurrecies([])
      setPaymentExchanges([])
    }
  }

  const generatePaymentWithReceipt = async () => {
    try {
      const reservationsObj = []
      let to_pay_count = 0
      for(const reserv of paymentData.form_data.reservation){
        if(Object.keys(reserv).length > 0){
          if(!reserv.amount_to_pay){
            notify('ra.message.amount_to_pay_requiered', {type:'error'})
            return
          }
          to_pay_count = to_pay_count + (reserv.amount_to_pay ?? 0)
          reservationsObj.push({
            /* amount_to_pay: getTotal(paymentData),
            amount_to_pay: reserv.amount_to_pay,
            number: reserv?.number,
            hash_reservation: reserv?.hash_reservation, */
            ...reserv,
            currency: currency?.hash_currency,
          })
        }
      }
      if(!getTotal(paymentData) || getTotal(paymentData).length === 0){
        notify('ra.message.amount_to_pay_requiered', {type:'error'})
        return
      }
      if(to_pay_count > getTotal(paymentData)){
        notify('ra.message.amount_to_pay_error', {type:'error'})
        return
      }
      if(!reservationsObj || reservationsObj.length === 0){
        notify('ra.message.noReservationsSelected', {type:'error'})
        return
      }
      const body = {
        paymentType: extractDetails(paymentData?.form_data?.paymentType),
        credit: paymentData?.form_data?.credit ?? [],
        date:paymentData?.form_data.date ?? '',
        hash_business_unit: paymentData?.hash_business_unit,
        currencies_exchange: reverseExchangeRate(paymentExchanges),
        amount: getTotal(paymentData),
        reservations: reservationsObj,
        generate_receipt: true,
      }
      setLoadingGeneratePaymentWithReceipt(true)
      const generatePayment = await paymentServices.liquidateExpensesReservations(body)
      if (generatePayment) {
        let numberReservations = []
        for(const reserv in paymentData?.form_data?.reservation){
          numberReservations.push(reserv.number)
        }
        onSuccessGeneratePayment(generatePayment, /* paymentData?.form_data?.reservation?.number */numberReservations)
        redirect('/payment-entity')
        setPaymentData(null)
      }
    } catch (error) {
      onErrorGeneratePayment(error, paymentData?.form_data?.reservation?.number)
    } finally {
      setLoadingGeneratePaymentWithReceipt(false)
      setPaymentCurrecies([])
      setPaymentExchanges([])
    }
  }

  const onAddReservation = () =>{
    const previousReserves = paymentData.form_data?.reservation
    const auxReservations = [...reservations]
    auxReservations.push({})
    setReservations(auxReservations)
    if(previousReserves){
      previousReserves.push({})
      paymentData['form_data'] = { ...paymentData.form_data, reservation: previousReserves }
      setPaymentData(paymentData)
    }
  }

  return (
    <>
      <Container className='content'>
        <CardCommon title={translate('ra.entity.reservation')}>
          <Box display={'flex'} justifyContent={'flex-end'}>
            {paymentExchanges.length > 0 && (
              <Box
                style={{
                  backgroundColor: '#bcf3bc',
                  border: '1px solid green',
                  borderRadius: '10px',
                  padding: '5px',
                }}
              >
                {paymentExchanges
                  .filter((currency) => !currency?.is_reverse)
                  .map((currency, index) => (
                    <div key={index}>
                      <Typography component='span' fontWeight='bold'>
                        {currency?.currency_relation?.short_name}-{currency?.currency_to_relation?.short_name}
                        : {currency.value}
                      </Typography>
                    </div>
                  ))}
              </Box>
            )}
          </Box>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <Typography variant='h6' component='h2'>
              {translate('ra.field.amount_to_apply')} {currency?.short_name} :{' '}
              {numberFormatterWithDecimalAndThousand(getTotal(paymentData))}
            </Typography>
          </Box>
          {reservations?.map((reserve, index)=>(
            <>
              <SearchComponent 
                reservation={reserve} 
                index={index} 
                reservations={reservations} 
                setReservations={setReservations}
                paymentData={paymentData} 
                setPaymentData={setPaymentData}
                setWasFound={setWasFound}
              />
            </>
          ))}
          <EditInputsWrap label={null} md={3} lg={3}>
          <Button
            variant='contained'
            onClick={()=>{
              /* setReservationAmount(reservationAmount + 1) */
              onAddReservation()
            }}
          >
            {translate('ra.action.add_reservation')}
          </Button>
        </EditInputsWrap>
          <Box display={'flex'} margin={'20px'}>
            <Box flex={1} display={'flex'} justifyContent={'flex-start'}>
              <LoadingButton
                className='button'
                variant='contained'
                onClick={() => {
                  redirect('/payment-entity')
                  setPaymentData({ ...paymentData, is_back: true })
                }}
                style={{ margin: '10px' }}
              >
                {translate('ra.action.back')}
              </LoadingButton>
            </Box>
            <Box flex={1} display={'flex'} justifyContent={'flex-end'}>
              {paymentData?.form_data?.credit_or_payment_type !== 'CREDIT' && (
                <LoadingButton
                  className='button'
                  variant='contained'
                  disabled={!wasFound}
                  onClick={generatePaymentWithReceipt}
                  loading={loadingGeneratePaymentWithReceipt}
                  style={{ margin: '10px' }}
                >
                  {translate('ra.action.finish_and_generate_receipt')}
                </LoadingButton>
              )}
              <LoadingButton
                className='button'
                variant='contained'
                disabled={!wasFound}
                loading={loadingGeneratePayment}
                onClick={generatePayment}
                style={{ margin: '10px' }}
              >
                {hasPermissionFunction('voucher', PERMISSION_RECEIPT)
                  ? translate('ra.action.finish_without_generate_receipt')
                  : translate('ra.action.finish')}
              </LoadingButton>
            </Box>
          </Box>
        </CardCommon>
      </Container>
    </>
  )
}
